"use client";

// This component must be used for every Link on the app router (exclusively or shared with the pages router)
// When the migration from the pages router to the app router is done, we can keep only this one and delete the Link.js file

import { Link, usePathname } from "@lib/i18n/navigation-app-router";
import classNames from "classnames";
import nProgress from "nprogress";

export default function LinkApp({
  children,
  href = "",
  className = "",
  noUnderline = false,
  disabled = false,
  onClick = () => {},
  ...other
}) {
  const pathname = usePathname();

  function handleClick(e) {
    if (disabled) {
      e.preventDefault();
      return;
    }

    nProgress.start();

    if (pathname === href) {
      nProgress.done();
    }

    onClick(e);
  }

  return (
    <Link
      href={href}
      className={classNames(className, noUnderline && "no-underline", disabled && "disabled")}
      onClick={handleClick}
      {...other}
    >
      {children}
    </Link>
  );
}
